// Load the background first:
import './background_terramonitor';

// Collections
import './forests';
import './fields';
import './air_quality';
import './private';

// Individual layer groups:
import './buildings';
import './cifor_peatlands';
import './corine_land_cover';
import './culverts';
import './fi_biodiversity';
import './fi_bogs';
import './fi_building_energy_certificates';
import './fi_helsinki_solar_potential';
import './fi_property_id';
import './fi_soils';
import './fi_fish';
import './snow_cover_loss';

import './hedge_pilot_area';

// Special:
import './dataset_query';
